// extracted by mini-css-extract-plugin
export var clauseRow = "_bi-6";
export var emptyState = "_bi-d";
export var filterContent = "_bi-a";
export var filterGroup = "_bi-1";
export var filterGroupContainer = "_bi-0";
export var nestedGroup = "_bi-2";
export var nestedGroupContent = "_bi-b";
export var nestedGroupDepth1 = "_bi-3";
export var nestedGroupDepth2 = "_bi-4";
export var nestedGroupDepth3 = "_bi-5";
export var nestedGroupEmpty = "_bi-c";
export var operatorAnd = "_bi-8";
export var operatorOr = "_bi-9";
export var operatorToggle = "_bi-7";
export var removeGroupButton = "_bi-e";